package com.partejar.app.feature.entitlements.data

data class PersonalPlan(
    val code: String,
    val isFree: Boolean,
    val workspaceLimit: Int?,
    val memberLimit: Int?,
    val patientLimit: Int?,
    val annualReportEnabled: Boolean
)

data class PersonalEntitlement(
    val hasPlan: Boolean,
    val plan: PersonalPlan?,
    val ownedWorkspacesUsed: Long,
    val canCreateWorkspace: Boolean
)

data class WorkspaceEntitlement(
    val planCode: String,
    val isCurrentUserOwner: Boolean,
    val membersUsed: Long,
    val memberLimit: Int?,
    val patientsUsed: Long,
    val patientLimit: Int?,
    val annualReportEnabled: Boolean
)

sealed interface CommercialState<out T> {
    data object Loading : CommercialState<Nothing>
    data class Available<T>(val value: T) : CommercialState<T>
    data class TemporarilyUnavailable(val cause: Throwable? = null) : CommercialState<Nothing>
}

interface EntitlementRepository {
    suspend fun personal(): PersonalEntitlement
    suspend fun activateFree(): PersonalEntitlement
    suspend fun currentWorkspace(): WorkspaceEntitlement
}

class CommercialConstraintException(val code: String, cause: Throwable? = null) : Exception(cause)
